import type { CheckboxProps } from '@mui/material'
import { TableRow } from '@mui/material'
import type { SortableHeaderProps } from '@app/src/components/Table'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import React from 'react'
import { useIntl } from 'react-intl'
import type { Question } from '@app/src/types/resourceExplorer'
import { QUESTIONNAIRES_COLUMN_WIDTH } from './QuestionnairesCell'
import type { QuestionCheckboxCellProps } from './QuestionCheckboxCell'

interface StandardQuestionHeaderProps extends SortableHeaderProps {
  includeCheckboxHeader: boolean
  selectionProps?: Partial<QuestionCheckboxCellProps>
  questionsInPage?: Question[]
}

const CustomQuestionHeader: React.FC<StandardQuestionHeaderProps> = ({
  toggleSorting,
  activeSorting,
  includeCheckboxHeader,
  questionsInPage,
  selectionProps,
}) => {
  const { formatMessage } = useIntl()
  const { selectedQuestionIds, setSelectedQuestionIds, questionIdsAlreadyInQuestionnaire } = selectionProps || {}

  const remainingQuestions = questionsInPage?.filter(
    question => !questionIdsAlreadyInQuestionnaire?.includes(question.id),
  )

  const isChecked = remainingQuestions?.every(question => selectedQuestionIds?.includes(question.id))

  const handleCheckboxChange: CheckboxProps['onChange'] = (_e, checked) => {
    if (checked) {
      setSelectedQuestionIds?.(prev =>
        Array.from(new Set([...prev, ...(remainingQuestions?.map(question => question.id) ?? [])])),
      )
    } else {
      setSelectedQuestionIds?.([])
    }
  }

  return (
    <TableRow>
      {includeCheckboxHeader && (
        <TableHeaderCell
          label=""
          minWidth={TableCellWidth.EMPTY}
          checkbox={{ checked: isChecked, onChange: handleCheckboxChange, color: 'primary' }}
        />
      )}
      <TableHeaderCell label={formatMessage({ id: 'general.id' })} minWidth={TableCellWidth.EXTRA_SMALL} />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.question.name' })}
        sorting={{ name: 'questionText', toggleSorting, activeSorting }}
        minWidth={TableCellWidth.LARGE}
      />
      <TableHeaderCell label={formatMessage({ id: 'schemas.question.guidance' })} minWidth={TableCellWidth.SMALL} />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.question.questionnaires' })}
        minWidth={QUESTIONNAIRES_COLUMN_WIDTH}
      />
    </TableRow>
  )
}

export default CustomQuestionHeader
